<script>
import noUiSlider from "nouislider";

export default {
    props: {
        'min': {
            default: 0
        },
        'max': {
            default: 10
        },
        'step': {
            default: 1
        }
    },

    data() {
        return {
            sliderElement: null,

            isDragging: false
        }
    },

    mounted() {
        var slider = this.sliderElement = this.$refs['slider-element'];
        noUiSlider.create(slider, {
            start: this.values ? this.values : [this.value || 0],
            step: parseFloat(this.step) || 1,
            connect: false,
            animate: false,
            behaviour: "none",
            range: {
                'min': [parseFloat(this.min)],
                'max': [parseFloat(this.max)]
            }
        });

        slider.noUiSlider.on('set', () => {
            // value is an array of start and end value
            var value = slider.noUiSlider.get();

            this.$emit('input', value);
            this.$emit('change', value);
        });

        slider.noUiSlider.on('update', () => {
            if (slider.noUiSlider.target.classList.contains('initialized')) {
                this.$emit('update', slider.noUiSlider.get());
            } else {
                slider.noUiSlider.target.classList.add('initialized');
            }
        });

        // start dragging
        slider.noUiSlider.on('start', () => {
            this.isDragging = true;
        });

        // stop dragging
        slider.noUiSlider.on('end', () => {
            this.isDragging = false;
        });
    }
};
</script>
